<template>
    <div>
        <b-row>
            <b-col xs="12" md="6">
                <b-card>
                    <b-col cols="12">
                        <b-row>
                            <b-col cols="12" class="heading-icon">
                                <i :class="model.icon"></i> <h4>{{ this.$translateLabel(this.model.label) }} </h4>
                            </b-col>
                            <b-col cols="12">
                                <p>
                                {{ $t('integrations.storefront.description') }}
                                </p>
                            </b-col>
                        </b-row>
                    </b-col>

                    <StartTrialFooter :integration="model" @activate="activate" @deactivate="deactivate" :autoIntegrate="false"/>
                </b-card>
            </b-col>
        </b-row>

        <main-dialog v-model="setupWizard" title="Setup wizard" ok-title="Next" ok-only size="lg" hide-footer>
            <b-col sm="12">
                <form-wizard @onComplete="submit" v-if="!setupWizardDone">
                    <tab-content title="Host" :selected="true">
                    <b-form-group
                            :label="this.$t('hostname')"
                        >
                            <b-input-group>
                                <b-form-input type="text" v-model="setup.hostname"> </b-form-input>
                                <b-input-group-append>
                                    <b-input-group-text>{{ $t('ptklShop') }}</b-input-group-text>
                                    <div v-if="errors.hostname" class="invalid-feedback">
                                        <div class="error"> {{ errors.hostname }} </div>
                                    </div>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </tab-content>

                    <tab-content title="Brand">
                       <ImageField type="imagev2" v-model="logo" name="logo" :rules={} :label="this.$t('logo')" :publicUpload="true"/>

                        <b-col xs="12">
                            <b-form-group
                                :label="this.$t('brandPrimaryColor')"

                            >
                                <b-input type="color" v-model="setup.primaryColor" />

                            </b-form-group>
                        </b-col>
                        <b-col xs="12">
                            <b-form-group
                                :label="this.$t('brandSecondaryColor')"

                            >
                                <b-input type="color" v-model="setup.secondaryColor" />

                            </b-form-group>
                        </b-col>
                    </tab-content>
                </form-wizard>

                <div v-else>
                  {{ $t('yourStep') }} <router-link to="/admin/integrations/page/protokol-storefront" :exact="true" >{{ $t('storefrontPage') }}</router-link>.
                </div>


            </b-col>
        </main-dialog>
    </div>
</template>
<style>
.heading-icon {
    text-align: center;
}

.vue-step-wizard {
    width: 100%;
    background-color: inherit;
}
</style>
<script>
import {FormWizard, TabContent} from 'vue-step-wizard'
import StartTrialFooter from '../StartTrialFooter'
import ImageField from '@/components/form/Image'

import 'vue-step-wizard/dist/vue-step-wizard.css'
export default {
    components: {
        StartTrialFooter,
        FormWizard,
        TabContent,
        ImageField
    },
    props: {
        model: {
            Type: Object,
            default: function() {
                return {}
            }
        }
    },

    data: function() {
        return {
            setupWizard: false,
            setupWizardDone: false,
            setup: {
                hostname: ''
            },
            errors: {
                hostname: null,
                logo: null,
                primaryColor: null,
                secondaryColor: null
            }
        }
    },

    computed: {
        // integration data
        data() {
            return this.model.setup.data
        },

        logo: {
            get() {
                return this.setup.logo
            },

            set(val) {
                this.setup.logo = val.public_url
            }
        }
    },

    methods: {
        activate() {
            this.setupWizard = true
        },

        deactivate() {
            this.$store.dispatch("deactivateIntegration", this.model).catch(err => {
                this.$debugLog(err)
                this.$mainDialog.msgBoxOk(`${this.$t('failedToRemove')}.`)
            })
        },

        activate() {
            this.$store.dispatch("activateIntegration", this.model).catch(err => {
                this.$debugLog(err)
                this.$mainDialog.msgBoxOk(`${this.$t('failedToActivate')}.`)
            })
        }
    },

    mounted() {
        this.startSetupWizard = this.data.installed || true
    }
}
</script>
